import { whenZero } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import PreviouslyAllocated from './PreviouslyAllocated';

export interface Props {
  newLicenseAllocations: number;
  productLicensePublicName: string;
  activationsRemaining: number;
}

function OverAllocated({
  newLicenseAllocations,
  activationsRemaining,
  productLicensePublicName,
}: Props) {
  return (
    <div className="bg-yellow-50 border-1 border-yellow-400 rounded">
      <p className="text-sm p-3">
        {whenZero(newLicenseAllocations)
          .map(() => (
            <PreviouslyAllocated
              productLicensePublicName={productLicensePublicName}
              activationsRemaining={activationsRemaining}
            />
          ))
          .getOrElse(() => (
            <>
              <T
                kind="There is <span>{{count}} license activation</span> remaining for {{name}}."
                span={(content) => <span className="font-bold">{content}</span>}
                count={activationsRemaining}
                name={productLicensePublicName}
              />{' '}
              <T kind="If all participants enroll you may exceed the available activations." />
            </>
          ))}
      </p>
    </div>
  );
}

export default observer(OverAllocated);
